<a matRipple [routerLink]="link()" [class]="['button', `button-${theme()}`, `button-${size()}`]">
    @if (icon()) {
    <mat-icon [svgIcon]="icon()" />
    }
    <ng-content />
</a>